import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import LoanerInventoryForm from './LoanerInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

export const AddLoanerInventoryPane = ({
  title,
  onSubmit,
  organizations,
  descriptions,
  consignmentsTypes,
}) => {
  const formRef = useRef()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const dispatch = useDispatch()
  const createInventoryItems = (data) => {
    const payload = []
    data.inventory_items.forEach((element) => {
      let obj = { ...data }
      Object.keys(element).forEach((key) => {
        obj[key] = element[key]
      })
      payload.push(obj)
    })

    new rest.LoanerInventoryService()
      .makePostRequest(payload)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Loaner items  Added.'))
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.PLUS}
      </ReactBootstrap.Button>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <LoanerInventoryForm
          ref={formRef}
          organizations={organizations}
          descriptions={descriptions}
          consignmentsTypes={consignmentsTypes}
          onSubmit={createInventoryItems}
          enableBulkMode={true}
        />
      </SlidingPane>
    </>
  )
}
